import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useParams, useNavigate } from 'react-router-dom'
import '../../css/generals/paper.css'
import styles from '../../css/modals/Modal.module.css'
import Swal from 'sweetalert2'
import { postData } from '../../actions/servicesHttp'
import { popupSimple } from '../../components/generals/popups'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function ModalContentDownload ({ onHide, type, title, show, btnError, btnSuccess, identity, socketSendActions, realTime }) {
  const { t } = useTranslation('dashboardDevice')
  const { id } = useParams()
  const [files, setFiles] = useState(null)
  const navigate = useNavigate()

  function closeModal () {
    onHide()
    setFiles(null)
  }

  function inputFileHandling () {
    const input = document.querySelector('#inputFileCD')

    input.addEventListener('change', e => {
      const span = document.querySelector('#fancy_file_name_document')

      if (input?.files?.length === 0) {
        span.innerHTML = t('modalContentDownload.label2')
      } else if (input?.files?.length > 0) {
        span.innerHTML = input.files[0].name
        setFiles(input.files)
      }
    })
  }

  const uploadContent = async () => {
    const f = new FormData()

    if (files !== null) {
      for (let i = 0; i < files.length; i++) {
        f.append('files', files[i])
      }

      let timerInterval

      Swal.fire({
        title: t('modalContentDownload.message1'),
        html: '',
        timer: 30000,
        timerProgressBar: false,
        didOpen: () => {
          Swal.showLoading()
          timerInterval = setInterval(500)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }
      })

      const response = await postData('upload/content', f, navigate)

      if (response.data.length !== false) {
        let url = response.data.url
        url = url.trim()
        const splitUrl = url.split('/')
        downloadContent(url, splitUrl)
        setFiles(null)
        closeModal()
      } else {
        popupSimple('error', t('modalContentDownload.message2'))
      }
    } else {
      popupSimple('info', t('modalContentDownload.message3'))
    }
  }

  const downloadContent = async (url, fileName) => {
    const json = {
      action: 'install',
      data: {
        fileName: fileName[fileName.length - 2] + '.' + fileName[fileName.length - 1],
        url,
        type: 'content'
      },
      date: new Date(Date.now()),
      devicesId: type === 'devices' ? [parseInt(id)] : [],
      groupsId: type === 'groups' ? [parseInt(id)] : []
    }

    if (realTime) {
      socketSendActions([json])
      popupSimple('success', t('modalContentDownload.message4'))
    } else {
      const { data } = await postData('actions', [json], navigate)
      if (type === 'devices') {
        if ((data[0].result === true) && (Array.isArray(data[0].sendings)) && (data[0].sendings.length === 0)) {
          popupSimple('success', t('modalContentDownload.message5'))
        } else if ((data[0].result === true) && (Array.isArray(data[0].sendings)) && (data[0].sendings.length > 0) && (data[0].sendings.includes(identity))) {
          popupSimple('success', t('modalContentDownload.message4'))
        } else {
          popupSimple('error', t('modalContentDownload.message6'))
        };
      } else {
        if ((data[0].result === true)) {
          popupSimple('success', t('modalContentDownload.message5'))
        } else {
          popupSimple('error', t('modalContentDownload.message6'))
        }
      }
    }
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'backgroundChange'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.modalBackgroundChangeBody}>
                        <label>{t('modalContentDownload.label1')}</label>
                        <input type="file" accept="all" id="inputFileCD" name="files" className={styles.fancy_file}/>
                        <label htmlFor="inputFileCD" className={styles.fancy_file_label}>
                            <span className={styles.fancy_file_button} onClick={() => inputFileHandling()}>
                                <i className="pi pi-upload"></i></span>
                            <span className={styles.fancy_file_name}>
                                <span id="fancy_file_name_document">{t('modalContentDownload.label2')}</span>
                            </span>
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} variant="danger">
                        {btnError}
                    </Button>
                    <Button onClick={() => uploadContent()} variant="primary" id="btnModalSucess" >
                        {btnSuccess}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalContentDownload.propTypes = {
  onHide: PropTypes.func,
  type: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  identity: PropTypes.string,
  socketSendActions: PropTypes.func,
  realTime: PropTypes.bool
}
